import { Dispatch, SetStateAction, useState } from 'react';
import { Box, Flexed } from '../../../styles/GlobalComponents';
import { Button } from '../../../components/common/Button/Button';
import { Icon, IconApproveNFT } from '../../../styles/Icons';
import { WithdrawStepsEnum } from './types';
import { P1, P2, P3 } from '../../../styles/FontStyles';
import { useDisconnect } from 'wagmi';
import { CheckText } from '../../../components/common/CheckText';
import { WithdrawHub } from './WithdrawHub/WithdrawHub';
import { PackageTrading, UserPackage } from '../Portfolio.types';
import { colors } from '../../../styles/GlobalStyles';

interface Step6Props {
  setWithdrawStep: Dispatch<SetStateAction<WithdrawStepsEnum>>;
  setWalletAddress: Dispatch<SetStateAction<string | undefined>>;
  item: UserPackage | PackageTrading;
}

export const Step6 = ({
  setWithdrawStep,
  setWalletAddress,
  item
}: Step6Props) => {
  const { disconnect } = useDisconnect();
  const [checkbox, setCheckbox] = useState(false);

  const { id, nftId, image, name, price, dateOfPurchase } = item;

  return (
    <>
      <Flexed column center>
        <P1 bold caps center mb='40'>
          NFT Withdrawal
        </P1>

        <WithdrawHub
          id={id}
          title={name}
          image={image}
          price={price}
          nftId={nftId}
          dateOfPurchase={dateOfPurchase}
        />

        <Flexed>
          <CheckText
            checked={checkbox}
            onClick={() => setCheckbox(!checkbox)}
            text={''}
          />
          <P3 color={colors.neutral500} semiBold>
            By checking this box, you acknowledge and agree to the terms
            outlined in the{' '}
            <a
              href='https://resources.mavie.global/presentations/NFT_Withdrawal_Disclosure.pdf'
              target='_blank'
              rel='noopener noreferrer'
              style={{
                color: '#1499FF',
                cursor: 'pointer'
              }}>
              NFT Withdrawal Disclosure & Release of Liability.
            </a>{' '}
            This action signifies your acceptance of full ownership and
            responsibility for the NFT upon withdrawal.
          </P3>
        </Flexed>

        <Button
          mr='12'
          mt='20'
          disabled={!checkbox}
          onClick={() => {
            setWithdrawStep(WithdrawStepsEnum.CONNECT_WALLET);
            setWalletAddress('');
            disconnect();
          }}>
          Confirm Withdrawal
        </Button>
      </Flexed>
    </>
  );
};
